module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colla', {
    staticClass: "collapp-comment-box"
  }, [_c('colla', {
    staticClass: "collapp-comment-list"
  }, [_c('colla', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "collapp-spinner"
  }), _vm._v(" "), _c('colla', {
    staticClass: "collapp-ul"
  }, _vm._l((_vm.comments), function(comment) {
    return _c('comment', {
      attrs: {
        "comment": comment
      }
    })
  }))], 1), _vm._v(" "), _c('comment-form', {
    attrs: {
      "thread": _vm.thread
    },
    on: {
      "commented": _vm.updateComment
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2008b19c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CommentList.vue
// module id = 23
// module chunks = 0